export default "__VITE_ASSET__18c5177e__"